@if (slugService.getSlug() != "start") {
    <footer
        class="bg-neutral-800 mx-auto px-4 sm:px-6 lg:px-8 py-10 w-full text-white ~mt-8/24"
    >
        <div class="gap-6 grid grid-cols-2 lg:grid-cols-5 mb-10">
            <div class="flex lg:flex-row flex-col gap-6 col-span-2">
                <div class="flex flex-col gap-3">
                    <p class="font-semibold">
                        {{ "footer.findUsHere" | translate }}
                    </p>
                    <p class="mt-3 text-white text-xs sm:text-sm">
                        Winkler Straße 88<br />8962 Gröbming<br />{{
                            "footer.austria" | translate
                        }}
                    </p>
                    <app-social-media-links
                        class="flex fill-white mt-3"
                    ></app-social-media-links>
                </div>
                @if (footerData.value()?.data?.map) {
                    <app-map
                        [data]="footerData.value()!.data!.map"
                        class="m-0 p-0 w-96 max-w-[90vw] h-60 aspect-auto"
                    ></app-map>
                }
            </div>
            @if (footerData.hasValue()) {
                @for (
                    item of footerData.value().data.footerItems;
                    track $index;
                    let i = $index
                ) {
                    <div [style.grid-column-start]="4 + i">
                        <h4 class="font-semibold text-xs uppercase">
                            {{ item.linkItem.text }}
                        </h4>

                        <div class="space-y-3 grid mt-3 text-sm">
                            @for (
                                footerItem of item.subLinkItems;
                                track $index;
                                let j = $index
                            ) {
                                <a
                                    class="inline-flex gap-x-2 focus:outline-none hover:text-gray-200 focus:text-gray-200 hover:scale-105 transition-transform"
                                    [fragment]="
                                        navbarService.getFragmentFromLinkItem(
                                            footerItem
                                        )
                                    "
                                    [routerLink]="
                                        navbarService.getNavbarLink(
                                            footerItem,
                                            'apartment'
                                        )
                                    "
                                    >{{ footerItem.text }}</a
                                >
                                @if (
                                    i ===
                                        footerData.value()!.data.footerItems
                                            .length -
                                            1 &&
                                    j === item.subLinkItems.length - 1
                                ) {
                                    <a
                                        [routerLink]="[
                                            '/',
                                            this.languageService
                                                .getLanguageCode,
                                            'apartment',
                                            'buchen',
                                        ]"
                                        ><app-button [variant]="'secondary'">
                                            {{ "footer.book" | translate }}
                                        </app-button></a
                                    >
                                }
                            }
                        </div>
                    </div>
                }
            }
        </div>

        <div class="mt-5 pt-5 border-neutral-950 border-t">
            <div class="sm:flex sm:justify-between sm:items-center">
                <div class="flex flex-wrap items-center gap-3">
                    <app-language-selection
                        [isMinimal]="false"
                    ></app-language-selection>

                    <div class="space-x-4 text-sm">
                        <a
                            class="inline-flex gap-x-2 focus:outline-none text-white hover:text-gray-200 focus:text-gray-200"
                            [routerLink]="[
                                '/',
                                this.languageService.getLanguageCode,
                                'apartment',
                                'impressum',
                            ]"
                        >
                            {{ "footer.imprint" | translate }}
                        </a>
                        <span>|</span>
                        <a
                            class="inline-flex gap-x-2 focus:outline-none text-white hover:text-gray-200 focus:text-gray-200"
                            [routerLink]="[
                                '/',
                                this.languageService.getLanguageCode,
                                'apartment',
                                'datenschutz',
                            ]"
                        >
                            {{ "footer.dataProtection" | translate }}
                        </a>
                        <span>|</span>
                        <a
                            class="inline-flex gap-x-2 focus:outline-none text-white hover:text-gray-200 focus:text-gray-200"
                            [routerLink]="[
                                '/',
                                this.languageService.getLanguageCode,
                                'apartment',
                                'agb',
                            ]"
                        >
                            {{ "footer.termsAndConditions" | translate }}
                        </a>
                    </div>
                </div>
                <p class="mt-6">
                    Zehentmoar - Apartment - {{ "footer.farm" | translate }}
                </p>
            </div>
        </div>
    </footer>
}
